import { BrowserRouter, Routes, Route } from "react-router-dom"
import Navbar from './components/Navbar'
import Header from './components/Header'
import PatientListContainer from './components/PatientListContainer'
import PatientProfile from "./components/PatientProfile"
import Error403 from './components/Error403'
import Error401 from './components/Error401'
import Login from './components/Login'
import PrivateRoute from './components/PrivateRoute'
import PublicRoute from './components/PublicRoute'
import AdminRoute from './components/AdminRoute'
import AdminPanel from './components/admin/AdminPanel'
import CambiarPassword from './components/CambiarPassword'
import Footer from './components/Footer'
import './App.scss'
import { PatientProvider } from "./context/PatientContext"
import { UserProvider } from "./context/UserContext"

function App() {
  return (
    <div className='reactBody'>
      <BrowserRouter>
        <UserProvider>
        <PatientProvider>
          <Routes>
            <Route path="/login" element={
                <PublicRoute>
                  <Login />
                </PublicRoute>}/>

            <Route path="/cambiar-password" element={<CambiarPassword />}/>

            <Route path="/*" element={
                <PrivateRoute>
                  <>
                    <Header />
                    <Navbar />
                    <Routes>
                      <Route path="/" element={<PatientListContainer />} />
                      <Route path="/pacientes/:apellidoSlug/:nombreSlug" element={<PatientProfile />} />
                      <Route path="/admin" element={
                        <AdminRoute><AdminPanel /></AdminRoute>} />
                      <Route path="/error403" element={<Error403 />} />
                      <Route path="/error401" element={<Error401 />} />
                    </Routes>
                  </>
                </PrivateRoute>}/>
          </Routes>
          <Footer />
        </PatientProvider>
        </UserProvider>
      </BrowserRouter>
    </div>
  )
}

export default App
